import ApiService from "../../ApiService";

const AddReportMailService = {
    saveReportMail: (saveVO,successCallback, failureCallback) => {
        ApiService.post("/mobile/me/editreportmail/savereportmail", { saveVO }, successCallback, failureCallback);
    },
};

export default AddReportMailService;
